import SectionCard from "@/components/base/SectionCard";
import type { SalesPoint } from "@/types";
import { formatNumber } from "@/utils/format";

interface SalesChartProps {
  points: SalesPoint[];
}

export default function SalesChart({ points }: SalesChartProps) {
  const max = Math.max(...points.map((point) => point.value), 1);
  const total = points.reduce((sum, point) => sum + point.value, 0);

  return (
    <SectionCard
      title="حركة المبيعات"
      subtitle="حسب الفترات الزمنية المحددة"
      icon="ri-bar-chart-grouped-line"
      action={
        <span className="rounded-full bg-primary-50 px-3 py-1.5 text-xs font-semibold text-primary-700">
          الإجمالي {formatNumber(total)} ر.س
        </span>
      }
    >
      <div className="overflow-x-auto pb-2 -mx-1">
        <div
          className="h-64 flex items-end gap-2 sm:gap-3 min-w-max px-1"
          dir="ltr"
        >
          {points.map((point) => (
            <div
              key={point.label}
              className="group h-full flex flex-col items-center justify-end"
              style={{ width: `${Math.max(36, 900 / points.length)}px` }}
            >
              <span className="h-5 mb-1.5 text-xs font-semibold text-foreground-700 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
                {formatNumber(point.value)}
              </span>
              <div
                className="w-full rounded-t-md bg-primary-400 group-hover:bg-primary-600 transition-all duration-200"
                style={{ height: `${Math.max((point.value / max) * 82, 4)}%` }}
              ></div>
              <span className="mt-2 text-[11px] text-foreground-500 whitespace-nowrap">
                {point.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </SectionCard>
  );
}